import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=bf9e2d6c&scoped=true"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=bf9e2d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9e2d6c",
  null
  
)

export default component.exports